// HELPERS
// libs
import React from 'react';
import { Helmet } from 'react-helmet';

// Title while page is loading
function getLoadingHelmetTags(t) {
  return (
    <Helmet>
      <title>{`${t('pages.loading')}...${t('pages.site.separator')}${t('pages.site.resources')}${t('pages.site.separator')}${t('pages.site.mnbaq')}`}</title>
    </Helmet>
  );
}

// Helmet tags
function getHelmetTags(t, seoData = null, subtitle = null) {
  return (
    <Helmet>
      <title>
        {subtitle ?
          `${seoData && seoData.title} - ${subtitle}${t('pages.site.separator')}${t('pages.site.resources')}${t('pages.site.separator')}${t('pages.site.mnbaq')}`
          :
          `${seoData && seoData.title}${t('pages.site.separator')}${t('pages.site.resources')}${t('pages.site.separator')}${t('pages.site.mnbaq')}`
        }
      </title>
      <meta property="og:title" content={`${seoData && seoData.title}${t('pages.site.separator')}${t('pages.site.resources')}${t('pages.site.separator')}${t('pages.site.mnbaq')}`} />
      <meta name="og:description" content={seoData && seoData.description} />
      <meta name="og:image" content={seoData && seoData.image && seoData.image.medium} />
      <meta name="twitter:title" content={`${seoData && seoData.title}${t('pages.site.separator')}${t('pages.site.resources')}${t('pages.site.separator')}${t('pages.site.mnbaq')}`} />
      <meta name="twitter:description" content={seoData && seoData.description} />
      <meta name="twitter:image" content={seoData && seoData.image && seoData.image.medium} />
    </Helmet>
  );
}

export { getHelmetTags, getLoadingHelmetTags };



// WEBPACK FOOTER //
// ./src/app/components/tools/helmetHelpers.js